// ActsProvider.jsx
import { createContext, useContext, useRef, useMemo } from 'react'

const ActsCtx = createContext(null)

export function ActsProvider({ children }) {
  const registry = useRef(new Map())

  const api = useMemo(() => ({
    set(id, patch) {
      const prev = registry.current.get(id) || {}
      registry.current.set(id, { ...prev, ...patch })
    },
    get(id) {
      return registry.current.get(id)
    },
    delete(id) {
      registry.current.delete(id)
    },

    setProgress(id, progress) {
      const prev = registry.current.get(id) || {}
      prev.progress = progress           // mutation ok: pas de re-render
      registry.current.set(id, prev)
    },
    getProgress(id) {
      return registry.current.get(id)?.progress
    },

    has(id) { return registry.current.has(id) },
    ids()   { return Array.from(registry.current.keys()).sort((a,b)=>a-b) },
  }), [])

  return <ActsCtx.Provider value={api}>{children}</ActsCtx.Provider>
}

export function useActs() {
  const ctx = useContext(ActsCtx)
  if (!ctx) throw new Error('useActs must be used inside <ActsProvider>')
  return ctx
}
